import { render, staticRenderFns } from "./SettingsAdminConsent.vue?vue&type=template&id=1ee03135&scoped=true&"
import script from "./SettingsAdminConsent.vue?vue&type=script&lang=ts&"
export * from "./SettingsAdminConsent.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsAdminConsent.vue?vue&type=style&index=0&id=1ee03135&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee03135",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee03135')) {
      api.createRecord('1ee03135', component.options)
    } else {
      api.reload('1ee03135', component.options)
    }
    module.hot.accept("./SettingsAdminConsent.vue?vue&type=template&id=1ee03135&scoped=true&", function () {
      api.rerender('1ee03135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/settings/SettingsAdminConsent.vue"
export default component.exports